import {useEffect, useState} from "react"
const GameIcons = ({ toggle, setToggle, color }) => {
  const [theme, setTheme] = useState("light");

  // Retrieve the theme from localStorage or set default
  useEffect(() => {
    const savedTheme = localStorage.getItem("theme") || "light";
    setTheme(savedTheme);
  }, [toggle]);

  // Define theme-specific colors
  const themeColors = {
    light: "#03A9F4", // Light theme color
    dark: "#FFEB3B",  // Dark theme color
  };

  const fillColor = themeColors[theme]; // Get the color based on the theme
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        stroke={fillColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
        d="m9.57 12.46-3.05 3.05M6.55 12.49l3.05 3.05"
      />
      <path
        stroke={fillColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
        strokeWidth={2}
        d="M13.53 14h.01M17.47 14h.01M15.5 15.98v-.02M15.5 12.04v-.02"
      />
      <path
        stroke={fillColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M9 22h6c5 0 7-2 7-7v-2c0-5-2-7-7-7H9c-5 0-7 2-7 7v2c0 5 2 7 7 7ZM13.01 2 13 3.01A1 1 0 0 1 12 4h-.03c-.55 0-.99.45-.99 1s.45 1 1 1h1"
      />
    </svg>
  );
}
export default GameIcons
